import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const AdminAuthApi = createApi({
  reducerPath: "AdminAuthApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/api/admin/`,
  }),
  tagTypes: ["AdminAuth"],
  endpoints: (builder) => ({
    getSingleAdminData: builder.query({
      query: (id) => `view/${id}`,
    }),
    AdminDataStore: builder.mutation({
      query: (data) => ({
        url: "store",
        method: "POST",
        body: data,
      }), 
      invalidatesTags: (results, error) => [
        { type: "AdminAuth", results, error, id: "Admin" },
      ],
    }),
   
    LogoutAdmin: builder.mutation({
      query: () => ({
        url: "logout",
        method: "POST",
      }),
    }),
  }),
});
 
export const {
  useGetSingleAdminDataQuery,
  useAdminDataStoreMutation,
  useLogoutAdminMutation,
} = AdminAuthApi;
